import type { FontFamilyToken } from '../types';

/**
 * Metadata-only token for PP Mori. Holds the CSS family name and named
 * weight aliases — no font binaries, so importing this carries zero bundle
 * cost. To actually load faces, import the variants you need (e.g.
 * `ppMoriRegular`, `ppMoriBold`) and pass them to `<FontProvider>`. Webpack
 * tree-shakes the variant modules you don't reference, so an app that
 * ships only Regular/Bold won't include the other 14 face files.
 */
export const ppMori: FontFamilyToken = {
  family: 'PP Mori',
  weights: {
    extraLight: 200,
    light: 300,
    book: 350,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
  },
};

export * from './variants';
